<template>
  <div 
    class="floating-logo" 
    :class="[size, colorVariant]"
    @click="$emit('click', $event)"
  >
    <div class="logo-circle">
      <span class="logo-text">H</span>
    </div>
    <span v-if="showLabel" class="v-kids-label">v-kids</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  size?: 'sm' | 'md' | 'lg'
  color?: 'default' | 'gold' | 'purple'
  showLabel?: boolean
}>()

defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<style scoped>
.floating-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  animation: floatLogo 4s ease-in-out infinite;
}

.floating-logo.sm { --logo-size: 40px; --font-size: 1.2rem; --label-size: 0.7rem; }
.floating-logo.md { --logo-size: 56px; --font-size: 1.6rem; --label-size: 0.85rem; }
.floating-logo.lg { --logo-size: 72px; --font-size: 2rem; --label-size: 1rem; }

.floating-logo.default .logo-circle { 
  background: linear-gradient(135deg, var(--vh-azul-profundo), var(--vh-azul-cielo)); 
}
.floating-logo.gold .logo-circle { 
  background: linear-gradient(135deg, var(--hero-gold), var(--hero-gold-dark)); 
}
.floating-logo.purple .logo-circle { 
  background: linear-gradient(135deg, var(--hero-purple), var(--hero-purple-light)); 
}

.logo-circle {
  width: var(--logo-size);
  height: var(--logo-size);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.logo-text {
  color: white;
  font-family: 'League Spartan', sans-serif;
  font-weight: 800;
  font-size: var(--font-size);
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.v-kids-label {
  font-family: 'Barlow', sans-serif;
  font-weight: 600;
  font-size: var(--label-size);
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--hero-gold);
}

.floating-logo:hover .logo-circle {
  transform: scale(1.1) rotate(-5deg);
  box-shadow: var(--hero-gold-glow);
}

@keyframes floatLogo {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}
</style>